import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireInternalOrganisation } from '@/lib/staffGate.ts';

/*
 * Data insights is one of Wundo's own tools: it reads across every
 * organisation, so it is ours to run rather than a customer's. Every route
 * under it was `requiresSuperadminInternal` in the Vue router, and the gate is
 * on the layout rather than repeated five times below it.
 */
export const Route = createFileRoute('/_app/insights')({
  beforeLoad: ({ context }) => requireInternalOrganisation(context.queryClient),
  component: () => <Outlet />,
});
